import firebase from 'gatsby-plugin-firebase';
// import useDeviceInfo from './useDeviceInfo';

type FirebaseEventType =
    | 'sign_up_google_form_button_clicked'
    | 'coaching_how_does_it_work_button_click'
    | 'coaching_intro_block_impression'
    | 'coaching_testimony_impression'
    | 'coaching_provider_statement_impression'
    | 'website_coach_page_cta_click'
    | 'website_therapy_page_cta_click'
    | 'website_home_page_cta_click';

const useAnalytics = () => {
    function logFirebaseEvent(eventType: FirebaseEventType, data?: any) {
        if (firebase) {
            // TODO: re-enable and fix on mobile safari
            // const { getDeviceId } = useDeviceInfo();
            // Log info
            firebase.analytics().logEvent(eventType, {
                ...data,
                deviceId: null,
            });
        }
    }

    return { logFirebaseEvent };
};

export default useAnalytics;
